import { render, staticRenderFns } from "./AddPlant.vue?vue&type=template&id=64f7f0f1&"
import script from "./AddPlant.vue?vue&type=script&lang=js&"
export * from "./AddPlant.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports